module.exports = __webpack_public_path__ + "img/Teatro.cdf43681.svg";